var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Link = require('react-router').Link;
var LinkWrapper = require('../../../components/linkWrapper.jsx')(Link);

var SurveyEntryMyGi = createReactClass({
    mixins: [PureRenderMixin],

    handleClick: function(e){
        e.preventDefault();
        this.props.showModal('MODAL_TYPE_PROMIS');
    },

    render: function(){
        var labelText = this.props.daysBeforeLatestSurvey === 0 ? "Track again tomorrow" : (this.props.labelText || "Update Your Symptoms");
        var className = 'survey-entry button ' + (this.props.daysBeforeLatestSurvey === 0 ? 'secondary' : (this.props.className || ''));

        return (
            this.props.daysBeforeLatestSurvey !== 0
                ?
                <LinkWrapper
                    className={className}
                    to="/dashboard/surveys/promis"
                    action={labelText}
                    handler={this.props.clickTracking}>
                    {labelText}
                </LinkWrapper>
                : (
                    this.props.showModal
                    ? <a className={className} onClick={this.handleClick}>{labelText}</a>
                    : null
                )

        )
    }
});

module.exports = SurveyEntryMyGi;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/layout/surveyEntryMyGi.jsx